
export const brokers = [
  {
    id: 1,
    name: "Angel One",
    logo: "🔺",
    color: "from-secondary-400 to-secondary-600",
  },
  {
    id: 2,
    name: "Zerodha",
    logo: "📊",
    color: "from-primary-400 to-primary-600",
  },
  { id: 3, name: "Upstox", logo: "📈", color: "from-blue-400 to-blue-600" },
  { id: 4, name: "Groww", logo: "🌱", color: "from-green-400 to-green-600" },
  {
    id: 5,
    name: "ICICI Direct",
    logo: "🏦",
    color: "from-purple-400 to-purple-600",
  },
  {
    id: 6,
    name: "HDFC Securities",
    logo: "💼",
    color: "from-indigo-400 to-indigo-600",
  },
];

export const brokerDetails = {
  "Angel One": {
    rating: 4.7,
    activeClients: "75L+",
    brokerage: "0.03%",
    features: ["Low Brokerage", "Advanced Charts", "Mobile App"],
    description:
      "One of India's leading discount brokers with advanced trading platforms.",
  },
  Zerodha: {
    rating: 4.6,
    activeClients: "80L+",
    brokerage: "0% (Delivery)",
    features: ["Zero Brokerage", "Kite Platform", "Research Tools"],
    description:
      "India's largest stock broker with zero brokerage on delivery trades.",
  },
  Upstox: {
    rating: 4.5,
    activeClients: "50L+",
    brokerage: "0.05%",
    features: ["Fast Execution", "API Trading", "Algo Trading"],
    description:
      "Technology-driven broker offering fast execution and API trading.",
  },
  Groww: {
    rating: 4.4,
    activeClients: "40L+",
    brokerage: "0.05%",
    features: ["User Friendly", "Mutual Funds", "SIP"],
    description: "Simplified investing platform for stocks and mutual funds.",
  },
  "ICICI Direct": {
    rating: 4.3,
    activeClients: "30L+",
    brokerage: "0.50%",
    features: ["Full Service", "Research Reports", "Advisory"],
    description:
      "Full-service broker with comprehensive research and advisory services.",
  },
  "HDFC Securities": {
    rating: 4.2,
    activeClients: "25L+",
    brokerage: "0.50%",
    features: ["Full Service", "Portfolio Management", "Advisory"],
    description:
      "Trusted full-service broker with portfolio management services.",
  },
};

/** Subject options for the Contact form dropdown. */
export const contactSubjectOptions = [
  { value: "course", label: "Course Enquiry" },
  { value: "trading", label: "Trading Support" },
  { value: "broker", label: "Broker Comparison" },
  { value: "general", label: "General Enquiry" },
  { value: "other", label: "Other" },
];
